import { css } from 'styled-components';

export const detailsModalCommonVerticalPadding = css`
  padding-left: 1em;
  padding-right: 1em;
`;
export const detailsModalCommonHorizontalPadding = css`
  padding-top: 1em;
  padding-bottom: 1em;
`;
